var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 42,
    viewBox: "0 0 161 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H160.447V26.7412L137.717 41.4488H0V0Z",
    fill: "#F36F21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.447 28.0776V30.0832L142.397 41.4483H139.723L160.447 28.0776Z",
    fill: "#BF5516"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundButton);
export default __webpack_public_path__ + "static/media/background_button.135c6fbecf0cac8c738fb4f680e43175.svg";
export { ForwardRef as ReactComponent };